import React from "react";
import {CategoryVideo} from "../../../types";

type BackgroundVideoProps = {
    video: CategoryVideo;
    description?: string;
    typeDescription?: string;
    title?: string;
    showBackdrop?: boolean;
    height?: number;
    children?: React.ReactNode;
};

export default function BackgroundVideo({
                                            video,
                                            showBackdrop,
                                            children
                                        }: BackgroundVideoProps) {
    const {youtubeVideoId, title: videoTitle} = video;

    return (
        <div className="relative w-full h-[500px] overflow-hidden">
            <div className="absolute inset-0 z-0">
                <iframe
                    src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&mute=1&controls=0&modestbranding=1&showinfo=0&rel=0&loop=1&playlist=${youtubeVideoId}`}
                    title={videoTitle}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    className="
                        absolute top-1/2 left-1/2
                        -translate-x-1/2 -translate-y-1/2
                        w-[177.78vh] h-[100vh]
                        min-w-full min-h-full
                        pointer-events-none
                    "
                />
                {showBackdrop && <div className="absolute inset-0 bg-black/50 z-10"/>}
            </div>

            <div className="absolute inset-0 z0-1">
                {children}
            </div>
        </div>
    );
}
